// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7b7fd70c","732":"b426c7d4"}[chunkId] + ".chunk.js";
};